"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgLogoRight(props) {
    return (React.createElement("svg", __assign({ width: 170, height: 302, viewBox: "0 0 170 302", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M164.829 269.864L58.721 164.25a18.599 18.599 0 01-5.433-13.129c0-4.918 1.953-9.637 5.433-13.128L164.829 32.352a13.508 13.508 0 003.989-9.574 13.509 13.509 0 00-3.989-9.573l-8.026-8.122a13.596 13.596 0 00-4.412-2.938 13.65 13.65 0 00-10.413 0 13.607 13.607 0 00-4.412 2.938L7.994 134.05a24.097 24.097 0 00-5.26 7.824 24.004 24.004 0 000 18.465 24.086 24.086 0 005.26 7.824l129.572 128.969a13.554 13.554 0 005.244 3.261c1.977.67 4.084.875 6.154.6a14.254 14.254 0 008.213-4.234l7.786-7.722a13.566 13.566 0 002.923-4.419 13.495 13.495 0 00-.072-10.377 13.558 13.558 0 00-2.985-4.378v0z", fill: "#fff", stroke: "#fff" })));
}
exports.default = SvgLogoRight;
//# sourceMappingURL=LogoRight.js.map